import type { DeploymentUnitsStatusCount } from '../../models/deployment/deploymentUnitList.model';
import type { PaginatedPublicLogicalDeviceList } from '../../models/logicalDeviceList.model';

export function mapDeployUnitsCountResponse(response: PaginatedPublicLogicalDeviceList): DeploymentUnitsStatusCount {
  return {
    completed: 0,
    canceled: 0,
    failed: 0,
    pending: 0,
    total: response.pagination.totalResults ?? 0,
  };
}
